import { createSlice } from "@reduxjs/toolkit";
const widgetsSlice = createSlice({
  name: "widgets",
  initialState: {
    newWidget: void 0
  },
  reducers: {
    setNewWidget: (state, action) => ({
      ...state,
      newWidget: action.payload
    })
  }
});
export const widgetsSliceReducer = widgetsSlice.reducer;
export const setNewWidget = (id) => (dispatch) => dispatch(widgetsSlice.actions.setNewWidget(id));
export const clearNewWidget = (id) => (dispatch, getState) => {
  if (getState().widgets.newWidget === id) {
    dispatch(widgetsSlice.actions.setNewWidget(void 0));
  }
};
export const selectNewWidget = (state) => state.widgets.newWidget;
